<div #login class="loginPage full-height">
    <a class="close-button pi pi-times" (click)="closeDialog()"></a>
    <div class="mainTitle">{{'LOGIN.MYֹ_ACCOUNT' | translate}}</div>
    <p-tabView *ngIf="isLoading" [(activeIndex)]="activeTabIndex">
        <p-tabPanel  [selected]="true" header="{{'LOGIN.ENTRANCE'|translate}}">
        <app-login *ngIf="activeTabIndex==0"></app-login>
        </p-tabPanel>
        <p-tabPanel header="{{'REGISTER.REGISTER'|translate}}">
            <app-register *ngIf="activeTabIndex==1" (registerSucceeded)="activeTabIndex=0"></app-register>
        </p-tabPanel>
    </p-tabView>
</div>